import React, { Component } from 'react';

class Block extends Component {
    render() {
        return (
            <div className="container profile-block container padding-bottom">
                { this.props.title && <div className="col-sm-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8"> <h4 className="h4 brand-color text-center">{ this.props.title }</h4></div> }
                { this.props.description && <p className="p-tag">{ this.props.description }</p> }
                { this.props.children }
            </div>
        );
    };
}

export default Block;



// WEBPACK FOOTER //
// src/client/components/common/elements/Block.js